import React from 'react';
import { Accordion } from './ui/Accordion';
import { AnimatedSection } from './ui/AnimatedSection';
export function FAQ() {
  const faqs = [{
    q: '¿Para qué año de la carrera está pensado el Atlas Clínico?',
    a: 'Está diseñado para estudiantes de kinesiología en etapas intermedias y avanzadas de la carrera, especialmente quienes ya cursan materias clínicas, traumatología, musculoesquelético, prácticas o internado. También es ideal para kinesiólogos recién graduados que quieren estructurar mejor su evaluación clínica. No está pensado como introducción para primeros años sin base anatómica y biomecánica previa.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de confirmar el pago recibís un mail con el link de descarga. Acceso en menos de 5 minutos. Los archivos son PDF de alta calidad, listos para leer en pantalla o imprimir.'
  }, {
    q: '¿Qué lo diferencia de los apuntes de la facultad o del material online?',
    a: 'Los apuntes de la facultad te dan información. El Atlas Clínico te da un sistema. La diferencia es la organización, la integración y la aplicación práctica. Todo el material está pensado para ser consultado antes, durante y después de una evaluación clínica real, no solo para leerlo antes de un examen.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si abrís el material y no es lo que esperabas, escribís un mail y te devolvemos el 100% del pago sin preguntas. Menos del 1% de los compradores pide devolución.'
  }, {
    q: '¿Puedo usarlo si ya estoy trabajando como kinesiólogo?',
    a: 'Sí, y de hecho muchos kinesiólogos junior lo usan exactamente para eso: estructurar mejor su evaluación, recordar tests que no usan seguido y ganar seguridad en regiones donde se sienten menos fuertes. El Tomo 5 y el Tomo 6 son especialmente útiles para profesionales en ejercicio.'
  }, {
    q: '¿Está basado en evidencia científica?',
    a: 'Sí. Todos los valores de sensibilidad, especificidad y likelihood ratio del Tomo 5 están basados en la bibliografía clínica internacional más actualizada. El contenido de los 6 tomos sigue los estándares de la kinesiología musculoesquelética basada en evidencia.'
  }];
  return <AnimatedSection className="bg-navy-900 border-y border-dark-border" data-id="element-36">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-37">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-center mb-10 sm:mb-12 leading-tight" data-id="element-38">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-2" data-id="element-39">
          {faqs.map((faq, idx) => <Accordion key={idx} question={faq.q} answer={faq.a} data-id="element-40" />)}
        </div>
      </div>
    </AnimatedSection>;
}